import { useGetApiV1LocationCountries } from '@/shared/api/generated';

/**
 * Tamanho de página usado na paginação **client-side** da listagem de Países.
 *
 * TODO: remover a paginação client-side quando o backend implementar paginação
 * server-side em `GET /api/v1/location/countries`. Hoje o endpoint retorna a
 * lista COMPLETA (sem `page`/`pageSize`/`total`), então fatiamos no front.
 * Quando o backend passar a aceitar esses parâmetros: enviar `page`/`pageSize`
 * para `useCountryList`, usar `totalCount`/`totalPages` do envelope da resposta
 * e parar de fatiar a lista na página (`src/pages/_authenticated/location/countries`).
 */
export const COUNTRY_PAGE_SIZE = 10;

/**
 * Hook para listar os Países cadastrados.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/location/countries`, que
 * retorna a lista completa (sem paginação/busca server-side). Filtragem e
 * ordenação são feitas client-side na camada de UI.
 *
 * @returns Lista de países com estado de loading/error e `refetch`.
 *
 * @example
 * ```tsx
 * const { countries, isLoading } = useCountryList();
 * ```
 */
export function useCountryList() {
  const query = useGetApiV1LocationCountries();

  return {
    countries: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
